import Form from "../form";

let Barba = require('barba.js');

module.exports = Barba.BaseView.extend({
    namespace: 'contacts-page',

    onEnterCompleted: function () {
        let form = new Form('#contacts-form', {}, {
            url: '/ajax/feedback-form'
        });
    },

    onLeave: function () {

    }
});



// WEBPACK FOOTER //
// resources/assets/src/js/views/contacts-page.js